import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

let rc = require.context('.', false, /.vue$/)
rc.keys().forEach(file => {
  let cc = rc(file)
  let cn = 's' + file.replace(/^\.\//, '').replace(/\.\w+$/, '')
  Vue.component(upperFirst(camelCase(cn)), cc.default || cc)
})
